// Central config — update WhatsApp number here and it propagates site-wide.
// Format: digits only, with country code, no '+', spaces, or dashes.
// Example: "50688881234" for +506 8888-1234 (Costa Rica).
export const WHATSAPP_NUMBER = "50671716543";
export const WHATSAPP_DEFAULT_MSG_EN = "Hi Ship Costa Rica! I'd like more info about shipping.";
export const WHATSAPP_DEFAULT_MSG_ES = "¡Hola Ship Costa Rica! Me gustaría más información sobre envíos.";

export const EMAIL = "Greg@ShipCR.com";
export const FB_URL = "https://www.facebook.com/ShipCostaRica/";
export const PROFILE_URL = "https://trackmypackage.app/join/shipcostarica";

export const buildWhatsAppLink = (message) => {
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${WHATSAPP_NUMBER}${text}`;
};
